import React from 'react';

const MaskCircle: React.FC = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 128 128" {...props}>
    <circle cx="64" cy="64" r="60" stroke="#101010" strokeWidth="4"></circle>
    <path
      stroke="#101010"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="5"
      d="M80.267 74.38c1.198-4.352.074-8.466-2.51-9.188-2.584-.722-5.65 2.22-6.847 6.573-1.198 4.352-.074 8.466 2.51 9.188 2.584.722 5.65-2.22 6.847-6.573zM45.17 85.556l-.023-.011c-10.387-4.938-17.314-15.146-18.12-26.689l-.286-4.118c-.207-2.97 1.656-5.686 4.484-6.54 4.047-1.224 8.123 1.826 8.13 6.083v.534m42.99 30.741l.279-.129c10.603-4.855 17.716-15.172 18.532-26.88l.266-3.81c.206-2.969-1.657-5.685-4.485-6.54-4.047-1.223-8.123 1.827-8.128 6.084v.534M71.898 59.08l-4.78-3.202a6.96 6.96 0 00-8.05.205l-3.985 2.976m8.409 1.408V97.33"
    ></path>
    <path
      stroke="#101010"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="5"
      d="M66.624 97.165l-1.05.371a6.44 6.44 0 01-4.372-.032l-.148-.056c-17.02-6.29-26.463-24.63-21.764-42.275l.122-.457 1.025.035a26.01 26.01 0 0015.6-4.56l.145-.1a12.875 12.875 0 0114.606.01 26.016 26.016 0 0014.616 4.596l3.458.02c4.75 17.832-4.948 36.34-22.24 42.445l.002.003z"
    ></path>
  </svg>
);

export default MaskCircle;
